<div fxLayout="row" fxLayoutGap="15px">
  <mat-label class="field__label" fxFlex>
    {{fieldLabel}}<span *ngIf="fieldRequired"
                        class="mandatory-field"> *</span>
  </mat-label>
  <span *ngIf="fieldHelp" fxFlex="10" fxLayoutAlign="end center">
    <i class="fa fa-question-circle-o" aria-hidden="true" [matTooltip]="fieldHelp"></i>
  </span>
</div>
